<template>
    <Head title="Verification Submitted" />

    <GuestLayout>
        <div class="min-h-screen bg-white py-8 px-4 sm:px-6">
            <div class="mx-auto max-w-lg">
                <div class="mb-8">
                    <JetAuthenticationCardLogoColored class="h-10 w-auto" />
                </div>

                <h1 class="text-2xl font-bold text-gray-900">Thank you</h1>
                <p class="mt-3 text-sm text-gray-600">
                    Your rental history verification for {{ verification.applicant_name }} has been submitted.
                </p>
            </div>
        </div>
    </GuestLayout>
</template>

<script>
import GuestLayout from '@/Layouts/V2/GuestLayout.vue';
import JetAuthenticationCardLogoColored from '@/Jetstream/AuthenticationCardLogoColored.vue';
import { Head } from '@inertiajs/vue3';

export default {
    components: {
        GuestLayout,
        JetAuthenticationCardLogoColored,
        Head,
    },
    props: {
        verification: { type: Object, required: true },
    },
};
</script>
